export default "__VITE_ASSET__CQvqKSOz__"